import { formatMeasureValue } from '../lib/visualContract'
import { getMeasureMetadata } from '../lib/analyticalQuery'

/**
 * KPI — displays a single measure's value from a QueryResult's first row.
 * Read-only: takes `result` (already executed) and `measureKey` — never
 * calls an Adapter, never recomputes anything.
 */
export default function KPI({ result, measureKey }) {
  const row = result?.rows?.[0]
  const value = row?.values?.[measureKey]
  const { label } = getMeasureMetadata(measureKey)

  return (
    <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '16px 18px' }}>
      <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: '#9CA3AF', marginBottom: 6 }}>
        {label}
      </div>
      <div style={{ fontSize: 24, fontWeight: 800, color: '#0F1017' }}>
        {formatMeasureValue(measureKey, value)}
      </div>
    </div>
  )
}
